import { batchActions } from "redux-batched-actions";
import { fetchSearchResult } from "./ActionSearch";
import { fetchAutompleteResult } from "./ActionAutocomplete";
import { getSeasonInfo, getMajorLeagueNumber, getSeasonLeagues } from "helpers/seasons";
import { t } from "helpers/localization";
import { fetchWithSpinner, fetchWrapper as fetch } from "helpers/fetch";


export const TOGGLE_LEAGUE_AND_DIVISION = 'TOGGLE_LEAGUE_AND_DIVISION';
export const TOGGLE_RATING_LIST = 'TOGGLE_RATING_LIST';
export const TOGGLE_RATING_ERROR = 'TOGGLE_RATING_ERROR';
export const TOGGLE_RATING_FETCH = 'TOGGLE_RATING_FETCH';
export const SET_CROSS_REALM_LADDER = 'SET_CROSS_REALM_LADDER';
export const SET_CURRENT_CLAN_ID = 'SET_CURRENT_CLAN_ID';
export const SET_CURRENT_SEASON_TYPE = 'SET_CURRENT_SEASON_TYPE';
export const SET_CURRENT_SEASON = 'SET_CURRENT_SEASON';
export const SET_CURRENT_REALM = 'SET_CURRENT_REALM';
export const TYPE_GLOBAL_SEARCH = 'global';

let lastFetchUrl = '';

export const setCrossRealmLadder = isCrossRealmLadder => {
  return {
    type: SET_CROSS_REALM_LADDER,
    isCrossRealmLadder
  };
};

export const toggleRatingFetch = isFetching => {
  return {
    type: TOGGLE_RATING_FETCH,
    isFetching
  };
};

export const setLeagueAndDivision = ({
  league,
  division
}) => {
  return {
    type: TOGGLE_LEAGUE_AND_DIVISION,
    league,
    division
  };
};

export const setCurrentClanId = currentClanId => {
  return {
    type: SET_CURRENT_CLAN_ID,
    currentClanId
  };
};

export const toggleRatingList = ({
  ratingList,
  league,
  division
}) => {
  return {
    type: TOGGLE_RATING_LIST,
    ratingList,
    league,
    division
  };
};

export const toggleRatingError = (isError, errorMessage) => {
  return {
    type: TOGGLE_RATING_ERROR,
    isError,
    errorMessage
  };
};

export const toggleCrossRealmLadder = isCrossRealmLadder => {
  return function (dispatch, getState) {
    let state = getState();

    dispatch(setCrossRealmLadder(isCrossRealmLadder));
    if (state.searchResult.term !== '') {
      dispatch(fetchSearchResult('clansRating'));
    }
    dispatch(fetchAutompleteResult(state.autocomplete.foundByTerm, 'clansRating'));

    dispatch(getLeagueDivisionRating({
      league: state.clansRating.currentLeague,
      division: state.clansRating.currentDivision
    }));
  };
};

export const toggleLeague = (league, ladderIsUpdate) => {
  return function (dispatch, getState) {
    const state = getState();

    if (state.clansRating.currentLeague === league && !ladderIsUpdate && !state.clansRating.isError) return;

    const seasonLeagues = getSeasonLeagues(state.clansRating.currentSeason);
    const firstDivision = seasonLeagues[league].divisions.length - 1;
    const division = seasonLeagues[league].divisions[firstDivision].number;

    let ladderData = null;
    let clanId;

    if (state.currentAccount.clanId && state.clans.wowsLadder) {
      ladderData = state.clans.wowsLadder;

      if (ladderData.division === division && ladderData.league === league) {
        clanId = state.currentAccount.clanId;
      }
    }

    dispatch(getLeagueDivisionRating({ league, division, clanId }));
  };
};

export const toggleDivision = (division, ladderIsUpdate) => {
  return function (dispatch, getState) {
    const state = getState();

    if (state.clansRating.currentDivision === division && !ladderIsUpdate && !state.clansRating.isError) return;

    let league = state.clansRating.currentLeague;
    let ladderData;
    let clanId;

    const season = getSeasonInfo(state.clansRating.currentSeason);
    const firstLeague = getMajorLeagueNumber(season);

    if (league === undefined) {
      league = season.leagues[firstLeague].number;
    }

    if (state.currentAccount.clanId && state.clans.wowsLadder) {
      ladderData = state.clans.wowsLadder;

      if (ladderData.division === division && ladderData.league === league) {
        clanId = state.currentAccount.clanId;
      }
    }

    dispatch(getLeagueDivisionRating({ league, division, clanId }));
  };
};

export const setCurrentSeasonType = currentSeasonType => {
  return {
    type: SET_CURRENT_SEASON_TYPE,
    currentSeasonType
  };
};

export const setCurrentSeason = currentSeason => {
  return {
    type: SET_CURRENT_SEASON,
    currentSeason
  };
};

export const setCurrentRealm = currentRealm => {
  return {
    type: SET_CURRENT_REALM,
    currentRealm
  };
};

export const toggleCurrentSeasonType = seasonType => {
  return function (dispatch, getState) {
    let state = getState();

    dispatch(setCurrentSeasonType(seasonType));
    dispatch(getLeagueDivisionRating({ clanId: state.currentAccount.clanId }));
  };
};

export const toggleCurrentRealm = realm => {
  return function (dispatch, getState) {
    let state = getState();

    dispatch(setCurrentRealm(realm));
    dispatch(getLeagueDivisionRating({ clanId: state.currentAccount.clanId, realm }));
  };
};

export const toggleCurrentSeason = currentSeason => {
  return function (dispatch, getState) {
    let state = getState();

    dispatch(setCurrentSeason(currentSeason));
    dispatch(getLeagueDivisionRating({ clanId: state.currentAccount.clanId }));
  };
};

export const getLeagueDivisionRating = ({
  league,
  division,
  clanId,
  realm
}, withGlobalSpinner = false, ownClan = true) => {
  return function (dispatch, getState) {
    let currentUrl = '';
    let state = getState();
    let url = state.urls.ladderStructure;
    let id;

    if (ownClan) {
      const clanLadder = state.clans.wowsLadder[clanId];
      const isQualified = clanLadder && clanLadder.is_qualified;

      id = state.currentAccount.clanId;
      if (clanId && isQualified) {
        currentUrl = `${url}?clan_id=${clanId}`;
      } else if (league === undefined || !division) {
        currentUrl = url;
      } else {
        currentUrl = `${url}?league=${league}&division=${division}`;
      }
    } else {
      id = clanId;
      currentUrl = `${url}?clan_id=${clanId}`;
    }

    realm = realm || state.clansRating.currentRealm || TYPE_GLOBAL_SEARCH;

    const sep = url === currentUrl ? '?' : '&';
    currentUrl = `${currentUrl}${sep}season=${state.clansRating.currentSeason}`;
    currentUrl += `&realm=${realm}`;

    dispatch(setCurrentClanId(id));

    if (currentUrl === lastFetchUrl) {
      return { type: '' };
    } else {
      lastFetchUrl = currentUrl;
    }

    const season = getSeasonInfo(state.clansRating.currentSeason);
    const firstLeague = getMajorLeagueNumber(season);

    const promise = fetch(currentUrl).then(ratingList => {
      if (ratingList.errors || ratingList.error) {
        lastFetchUrl = '';
        dispatch(batchActions([setLeagueAndDivision({ league: firstLeague, division: 1 }), toggleRatingList({ league: firstLeague, division: 1 }), toggleRatingError(true, t('Произошла ошибка. Повторите попытку позже'))]));
      } else {

        let selectedLeague;
        let selectedDivision;

        if (ratingList.length) {
          selectedLeague = ratingList[0].league;
          selectedDivision = ratingList[0].division;
        } else {
          selectedLeague = league || firstLeague;
          selectedDivision = division || 1;
        }

        dispatch(batchActions([toggleRatingFetch(false), setLeagueAndDivision({
          league: selectedLeague,
          division: selectedDivision
        }), toggleRatingError(false, ''), toggleRatingList({
          ratingList,
          league: selectedLeague,
          division: selectedDivision
        })]));
      }
    }).catch(() => {
      lastFetchUrl = '';
      dispatch(batchActions([setLeagueAndDivision({ league: firstLeague, division: 1 }), toggleRatingList({ league, division }), toggleRatingError(true, t('Произошла ошибка. Повторите попытку позже'))]));

    });

    return withGlobalSpinner ? fetchWithSpinner(dispatch, promise) : promise;
  };
};